import { gql } from "lib/apolloClient";

export const getDPSubjectGroupsQuery = gql`
  query getDPSubjectGroups(
    $id: ID!
    $filters: SubjectGroupFilterInput
    $subjectFilters: SubjectFilterInput
    $flatSubjectVariantFilters: FlatSubjectVariantFilterInput
    $flatVariantsCourseFilters: FlatVariantsCourseFilters
    $subjectCourseFilter: SubjectCourseFilters
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        subjectGroups(filters: $filters) {
          id
          name
          type
          globalSubjectGroup {
            id
          }
          subjects(filters: $subjectFilters) {
            id
            name
            type
            icon
            iconType
            isArchived
            isInterdisciplinary
            subjectGroupOptions
            ibOfferedSubject {
              id
              contentSubject {
                id
                assessmentYearTitle
              }
            }
            flatVariants(filters: $flatSubjectVariantFilters) {
              level {
                id
                label
                globalTag {
                  id
                }
              }
              responseLanguage {
                id
                label
                globalTag {
                  id
                }
              }
              courses(filters: $flatVariantsCourseFilters) {
                totalCount
              }
              unitPlans {
                totalCount
              }
              isArchived
            }
            courses(filters: $subjectCourseFilter) {
              totalCount
            }
            unitPlans {
              totalCount
            }
          }
        }
      }
    }
  }
`;

export const getCurriculumGradesQuery = gql`
  query getCurriculumGrades(
    $id: ID!
    $filters: CurriculumProgramGradeFilters
    $curriculumInterfaceType: ENTITY_TYPE_ENUM!
  ) {
    node(id: $id, type: $curriculumInterfaceType) {
      ... on IbDpCurriculumProgram {
        id
        grades(filters: $filters) {
          id
          name
        }
      }
    }
  }
`;
